import React from 'react'
import NavControllerPannel from './AdminNavigationPanel/NavControllerPannel'

function App() {
  return (
    <NavControllerPannel/>
  )
}

export default App